import { createSlice } from '@reduxjs/toolkit';

const campaignCalendarSlice = createSlice({
  name: 'campaignCalendar',
  initialState: {
    showCalendar: false,
  },
  reducers: {
    setShowCalendar: state => ({ ...state, showCalendar: !state.showCalendar }),
    closeCalendar: state => ({ ...state, showCalendar: false }),
  },
});

export const {
  setShowCalendar,
  closeCalendar,
} = campaignCalendarSlice.actions;
export default campaignCalendarSlice.reducer;
